import type { IconSvgObject } from './types';

const Root01Icon: IconSvgObject = [
  ["path", { d: "M14.35 11H15.2348C15.765 11 16.2498 11.321 16.487 11.8292L18.513 16.1708C18.7502 16.679 19.235 17 19.7652 17H20.65M21 11H20.5853C20.1816 11 19.7975 11.1867 19.5317 11.5122L15.4683 16.4878C15.2025 16.8133 14.8184 17 14.4147 17H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 5.00016L12.729 5.00001C12.2946 5 11.9099 5.28044 11.7769 5.694L7.5 19L4.65366 14.1206C4.32327 13.5542 3.54636 13.4537 3.08274 13.9174L2 15.0002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Root01Icon;
